// extracted by mini-css-extract-plugin
export default {"mainDiv":"errorpage_mainDiv__Fh9+U","error":"errorpage_error__zDVPl","subError":"errorpage_subError__DAJsF","backBtn":"errorpage_backBtn__rRAle"};